import { formLimitation } from 'const';

class Form {
  theme = null;

  constructor(theme) {
    this.theme = theme;
    Form.instance = this;
  }

  static init(theme) {
    Form.instance = null;
    return new Form(theme);
  }

  getRowStyle() {
    return {
      marginLeft: "20px",
      marginTop: "20px",
      display: "flex",
      alignItems: "center",
      gap: 2,
    };
  }

  getLabelStyle() {
    return {
      width: "150px",
      color: this.theme.palette.primary.greyPrimary,
      fontSize: this.theme.typography.customFontSize[2],
      fontWeight: this.theme.typography.customFontWeight[0],
    };
  }

  getTextfieldStyle = (isValid) => ({
    width: "286px",
    "& .MuiOutlinedInput-root": {
      borderRadius: this.theme.shape.customBorderRadius[1],
      height: "31px",
      backgroundColor: this.theme.palette.primary.transparent,

      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: isValid
          ? this.theme.palette.primary.borderGreyPrimary
          : this.theme.palette.primary.redPrimary,
      },

      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: isValid
          ? this.theme.palette.primary.mainHover
          : this.theme.palette.primary.redPrimary,
      },

      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: isValid
          ? this.theme.palette.primary.main
          : this.theme.palette.primary.redPrimary,
      },
    },
  });

  checkPvid(value) {
    if (value === "") {
      return false;
    }

    if (!/^\d+$/.test(value)) {
      return false;
    }

    const intValue = Number(value);
    if (intValue < 1 || intValue > 4094) {
      return false;
    }

    return true;
  }

  checkAllowVlans(value) {
    const pattern = /^\s*(?:([1-9][0-9]{0,3})\s*(?:-\s*([1-9][0-9]{0,3}))?\s*,?\s*)*$/;
    const { min, max } = formLimitation.vlanId;

    if (!pattern.test(value)) return false;

    const parts = value.split(',').map(s => s.trim());
    for (let part of parts) {
      if (part.includes('-')) {
        const [startStr, endStr] = part.split('-').map(s => s.trim());
        const start = parseInt(startStr, 10);
        const end = parseInt(endStr, 10);

        if (
          isNaN(start) || isNaN(end) ||
          start < min || end > max ||
          start > end
        ) {
          return false;
        }
      } else {
        const num = parseInt(part, 10);
        if (isNaN(num) || num < min || num > max) {
          return false;
        }
      }
    }

    return true;
  }

  checkDynamicSize(value) {
    let isValid = true;

    if(value === "" || value < 1 || value > 32) {
      isValid = false;
    }

    return isValid;
  }
}

export default Form;